import React from "react";
import {
    Card,
    Row,
    Col,
    Progress,
    Typography,
    Divider,
    Avatar,
    Space
} from "antd";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined
} from "@ant-design/icons";
import {
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    AreaChart,
    Area
} from "recharts";
import AttendanceInfo from "./AttendanceInfo";
import PerformanceGauge from "./PerformanceGauge";
import DashboardMetrics from "./DashboardMetrics";
import AttendanceOvertimeDashboard from "./AttendanceOvertimeDashboard";
import PerformanceChart from "./PerformanceChart";
import WorkDashboard from "./WorkDashboard";
import WorkingHours from "./WorkingHours";
import DepartmentAndEmployee from "./DepartmentAndEmployee";
import RevenueReport from "./RevenueReport";
import ExpensesVsBilling from "./ExpensesVsBilling";
import TeamLeadPerformance from "./table/TeamLeadPerformance";

const { Title, Text } = Typography;

const workingHoursData = Array.from({ length: 31 }, (_, i) => ({
    day: i + 1,
    hours: [8, 0, 7, 6, 0, 9, 8, 0, 6, 7, 0, 9, 10, 8, 0, 6, 7, 0, 8, 9, 0, 6, 7, 0, 9, 8, 6, 0, 8, 8, 9][i]
}));

const overtimeData = [
    { name: "Jan Week 1", hours: 25 },
    { name: "Jan Week 2", hours: 15 },
    { name: "Jan Week 3", hours: 22 },
    { name: "Jan Week 4", hours: 20 }
];

const PerformanceDashboard: React.FC = () => {
    return (



        <div className="">


            <DashboardMetrics />
            <AttendanceOvertimeDashboard />
            <PerformanceChart />
            <WorkDashboard />
<WorkingHours />
<DepartmentAndEmployee />
<RevenueReport />
<ExpensesVsBilling />
<TeamLeadPerformance />


           
        </div>
    );
};

export default PerformanceDashboard;